(function (angular) {
  "use strict";

  angular.module("Toyota.Services").service("DealerSelector", [
    "UrlParser",
    "$rootScope",
    "Location",
    "Dealer",
    "Postcodes",
    "Tfy",
    "DebugLogger",
    "ParseBool",
    "CustomEvents",
    function (UrlParser, $rootScope, Location, Dealer, Postcodes, Tfy, DebugLogger, ParseBool, CustomEvents) {
      const exports = this;

      const DEALER_SELECTOR_CUSTOM_EVENT_NAME = {
        locationChanged: "tk:location-changed",
        selectedDealerChanged: "tk:selected-dealer-changed",
        dealerSelectorOpened: "tk:dealer-selector-opened",
        dealerSelectorClosed: "tk:dealer-selector-closed",
        openDealerSelector: "tk:open-dealer-selector",
      };

      const dealerSelectorCustomEvent = {
        locationChanged: CustomEvents.createDispatcherAndListener(DEALER_SELECTOR_CUSTOM_EVENT_NAME.locationChanged),
        selectedDealerChanged: CustomEvents.createDispatcherAndListener(
          DEALER_SELECTOR_CUSTOM_EVENT_NAME.selectedDealerChanged
        ),
        dealerSelectorOpened: CustomEvents.createDispatcherAndListener(
          DEALER_SELECTOR_CUSTOM_EVENT_NAME.dealerSelectorOpened
        ),
        dealerSelectorClosed: CustomEvents.createDispatcherAndListener(
          DEALER_SELECTOR_CUSTOM_EVENT_NAME.dealerSelectorClosed
        ),
        openDealerSelector: CustomEvents.createDispatcherAndListener(
          DEALER_SELECTOR_CUSTOM_EVENT_NAME.openDealerSelector
        ),
      };

      // This is a legacy function that is used to determine if the dealer selector is using the legacy system or not.
      // Since we are not using the legacy system, we can safely return false.
      exports.getIsUsingLegacy = () => false;

      exports.openDealerSelector = function (preventUrlFragment) {
        dealerSelectorCustomEvent.openDealerSelector.dispatch(true);
      };

      exports.getDealerLocationFallbackToGeolocation = () => {
        var dealer = Dealer.getSavedFallbackToDefault();
        var hasDealer = dealer.name;

        if (hasDealer) {
          return {
            postcode: dealer.postCode,
            suburb: dealer.city,
            state: dealer.state,
            region: dealer.region,
            pricingZone: dealer.pricingZone,
            locationString: `${dealer.name}, ${dealer.city}, ${dealer.state} ${dealer.postCode}`,
            dealerName: dealer.name,
            alternativeLocationString: `${dealer.city}, ${dealer.state} ${dealer.postCode}`,
          };
        }

        var location = Location.get();
        return {
          ...location,
          locationString: `${location.suburb},
            ${location.state} ${location.postcode}`,
        };
      };

      dealerSelectorCustomEvent.locationChanged.listener((e) => {
        const locationObject = e.detail;
        DebugLogger.log("tyDealerSelector", "locationChanged", locationObject);
        Location.update(
          locationObject.postCode,
          locationObject.suburb,
          locationObject.state,
          locationObject.region,
          locationObject.pricingZone,
          locationObject.source
        );
      });

      dealerSelectorCustomEvent.selectedDealerChanged.listener((e) => {
        const dealerObject = e.detail;

        if (dealerObject && typeof dealerObject.orderAndCollectFlag === "string") {
          dealerObject.orderAndCollectFlag = ParseBool(dealerObject.orderAndCollectFlag);
        }

        DebugLogger.log("tyDealerSelector", "selectedDealerChanged", dealerObject);

        (async () => {
          const tags = await Postcodes(dealerObject.postCode, 1);
          const pricingZone = tags?.[0]?.tagInfo?.pricingZone;

          var previousDealer = Dealer.getSaved();
          var defaultDealer = Dealer.getDefault();

          if (previousDealer && previousDealer.name) {
            if (!defaultDealer) {
              defaultDealer = {};
            }

            Dealer.updatePrevSaved(defaultDealer, previousDealer);
          }

          /*
           * Set dealer first, then location -- so that when prices re-render,
           * the dealer information is already available.
           */
          Dealer.updateDefault({ ...dealerObject, pricingZone });
          Dealer.updateSaved({ ...dealerObject, pricingZone });
          $rootScope.$broadcast("dealer-selected");

          // postcode, suburb, state, region, pricingZone
          Location.update(
            dealerObject.postCode,
            dealerObject.city,
            dealerObject.state,
            dealerObject.region,
            pricingZone,
            dealerObject.source
          );

          Tfy.updateDealerInTfyCookie(dealerObject.sapDealerCode, dealerObject.branchCode);
        })();
      });

      dealerSelectorCustomEvent.dealerSelectorOpened.listener((e) => {
        DebugLogger.log("tyDealerSelector", "dealerSelectorOpened", e);
        $rootScope.$broadcast("did-location-change-dealers-load-begin");
        $rootScope.$broadcast("did-dealer-selector-open");
      });

      dealerSelectorCustomEvent.dealerSelectorClosed.listener((e) => {
        DebugLogger.log("tyDealerSelector", "dealerSelectorClosed", e);
        $rootScope.$broadcast("did-location-change-dealers-load-end");
        $rootScope.$broadcast("did-dealer-selector-close");
      });

      return exports;
    },
  ]);
})(window.angular);
